import { Component, Input, OnInit } from '@angular/core';
import { ProductEvaluationTaskStatusEnum } from '../../../models/product-evaluation-tasks/enums/ProductEvaluationTaskStatusEnum';
import { StatusTask } from 'projects/admin/src/app/features/product-evaluation-tasks/models/ListData';

@Component({
  selector: 'app-product-evaluation-task-status',
  standalone: false,
  templateUrl: './product-evaluation-task-status.component.html',
})
export class ProductEvaluationTaskStatusComponent implements OnInit {

  @Input({ required: true }) status: StatusTask;
  taskStatus = ProductEvaluationTaskStatusEnum;

  constructor() { }

  ngOnInit() {
  }

}
